/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { Component } from 'react';
const fadeOutStyles = (maxHeight, top, backgroundColor) => css({
  position: 'relative',
  overflowY: 'hidden',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  maxHeight: `${maxHeight}px`,
  '&::after': {
    content: "''",
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: `${top}px`,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
  }
});
const FadeOut = props => {
  const {
    children,
    backgroundColor,
    fadeHeight,
    height
  } = props;
  const top = height - fadeHeight;
  const styles = fadeOutStyles(height, top, backgroundColor);
  // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
  return jsx("div", {
    css: styles
  }, children);
};
export class TruncatedWrapper extends Component {
  constructor(props) {
    super(props);
  }

  // TODO: Quality ticket as elevation.surface will be issue when sits top of modal. https://product-fabric.atlassian.net/browse/DSP-4123
  render() {
    const {
      height = 95,
      fadeHeight = 24,
      backgroundColor = "var(--ds-surface, white)",
      children
    } = this.props;
    return jsx(FadeOut, {
      height: height,
      fadeHeight: fadeHeight,
      backgroundColor: backgroundColor
    }, children);
  }
}